import React from 'react';
import { ResponsiveGrid } from '@alifd/next';
import PageHeader from '@/components/PageHeader';
import UpdateSystemBlock from './components/UpdateSystemBlock';

const { Cell } = ResponsiveGrid;

const SystemSetting = () => (
  <ResponsiveGrid gap={20}>
    <Cell colSpan={12}>
      <PageHeader
        title="系統更新"
        breadcrumbs={[
          {
            name: '設置頁面',
          },
          {
            name: '系統更新',
          },
        ]}
      />
    </Cell>

    <Cell colSpan={12}>
      <UpdateSystemBlock />
    </Cell>
  </ResponsiveGrid>
);

export default SystemSetting;
